import { ProfessionalGroup } from "src/types/snugtotal";

/**
 * Whether the logged-in professional may work with quitclaim deed requests
 * (nav item, /quitclaim-deeds page, request loading).
 *
 * `allow_quitclaim_deed` is the account-level switch set by Snug ops and
 * always applies. Agents are additionally gated by the firm admin's
 * `allow_agents_quitclaim_deeds`; admins are not.
 */
export const canAccessQuitclaimDeeds = (
  professionalGroup: ProfessionalGroup | null | undefined,
  isFirmAdmin: boolean
): boolean => {
  if (!professionalGroup?.allow_quitclaim_deed) return false;
  if (isFirmAdmin) return true;
  return professionalGroup.allow_agents_quitclaim_deeds ?? true;
};
